import React from 'react';
import ReactDOM from 'react-dom/client';
import AppUS from './AppUS';
import { initializeFirebase } from './services/firebase';
import './index.css';

initializeFirebase()
  .then(() => {
    const root = ReactDOM.createRoot(document.getElementById('root')!);
    root.render(
      <React.StrictMode>
        <AppUS />
      </React.StrictMode>
    );
  })
  .catch((error) => {
    console.error('Failed to initialize Firebase:', error);
    console.error('Error details:', {
      message: error.message,
      stack: error.stack,
      name: error.name
    });
    const root = ReactDOM.createRoot(document.getElementById('root')!);
    root.render(
      <React.StrictMode>
        <div style={{ padding: '20px', textAlign: 'center' }}>
          <h1>Initialization Error</h1>
          <p>Failed to connect to Firebase. Please refresh the page.</p>
          <details style={{ marginTop: '20px', textAlign: 'left', maxWidth: '600px', margin: '20px auto' }}>
            <summary style={{ cursor: 'pointer' }}>Error Details</summary>
            <pre style={{ background: '#f5f5f5', padding: '10px', borderRadius: '4px', overflow: 'auto' }}>
              {error.message}
              {error.stack && `\n\n${error.stack}`}
            </pre>
          </details>
        </div>
      </React.StrictMode>
    );
  });
